import { gsap } from "gsap";
import GS, { Direction } from "../../ts/GlobalSetting";

export type TextBubbleOptions = {
  targetIsFixed?: boolean
  icon?: string
  direction?: Direction
}

export default class TextBubble
{
  static instance: TextBubble;

  $root: JQuery;

  constructor()
  {
    this.$root = $(`<div component="text-bubble"><div class="deco"></div><div class="text"></div></div>`);
  }

  popupAt(elem: HTMLElement, contentHtmlText: string = "", options?: TextBubbleOptions)
  {
    options = options || {
      targetIsFixed: false,
      direction: Direction.Bottom
    };

    this.$root.attr("icon", options.icon || "");

    this.$root.find(".text")[0].innerHTML = contentHtmlText;

    let $container = $(`#dropdown-menus`);

    this.$root.css(`position`, options.targetIsFixed ? "fixed" : "");



    let bound = elem.getBoundingClientRect();
    // console.log(bound);
    let containerBound = $container[0].getBoundingClientRect();

    $container.append(this.$root);

    let myBound = this.$root[0].getBoundingClientRect();

    let result: any = this._getPosition(options.targetIsFixed, bound, containerBound, myBound, options.direction);
    result.clearProps = "opacity";

    gsap.killTweensOf(this.$root);
    gsap.set(this.$root, result);
    gsap.to(this.$root, {
      duration: .25, opacity: 0, delay: 1.7, ease: "power1.in", onComplete: () =>
      {
        this.$root.detach();
      }
    });
  }

  private _getPosition(targetIsFixed: boolean, targetBound: DOMRect, containerBound: DOMRect, myBound: DOMRect, direction: Direction = Direction.Bottom): { left: number, top: number }
  {
    let left = targetIsFixed ? 0 : -containerBound.x,
      top = targetIsFixed ? 0 : -containerBound.y;

    let $deco = this.$root.find(".deco");
    $deco.css({ "left": "", "margin-left": "" });

    switch (direction) {
      case Direction.Bottom:
        left += targetBound.x + (targetBound.width * .5) - (myBound.width * .5);
        top += targetBound.bottom + 15;
        break;

      case Direction.BottomRight:

        $deco.css({
          "left": myBound.width - targetBound.width*.5
        });
        left += targetBound.x + targetBound.width - myBound.width;
        top += targetBound.bottom + 15;
        break;

    }

    return { left: left, top: top };
  }
}